import { useEffect, useState } from "react";
import AuthService from "../services/AuthService";
import { TitleTable } from "../components/TitleTable";
import { Loading } from "../components/Loading";
import { Button, Typography } from "@mui/material";
import DataService from "../services/DataService";
import { useNavigate } from "react-router-dom";
import MemberService from "../services/MemberService";
import EmptyTypesService from "../services/EmptyTypesService";
import EnumToStringService from "../services/EnumToStringService";


interface PersonalDataProps {
    isMobile: boolean
    config: Config
}
declare global {
    type Member = {
        id: string,
        address_city: string,
        address_extra: string,
        address_postalcode: string,
        address_street: string,
        isMember: boolean,
        isMemberSince: Date,
        primaryEmail: string,
        name: string,
        memberNumber: string,

        salutation: string,
        firstname: string,
        lastname: string,
        birthdate: string,
        birthplace: string,
        birthname: string,
        taxNumber: string,
        title: string

        taxIdNumber: string,
        website: string,

        phone: string,
        type: string,
    }
    type Bank_Account = {
        id: string,
        name: string,
        iban: string,
        debit: boolean,
        bank: {bic:string,name:string},
        bankAccountTypes: string[]
    }
}


export const PersonalData: React.FC<PersonalDataProps> = (props) => {
    const navigate = useNavigate();
    const [finishedLoading, setFinishedLoading] = useState<{member: boolean, bank: boolean}>({member: false, bank: false});
    const [memberData, setMemberData] = useState<Member>(EmptyTypesService.emptyMember());
    const [bankData, setBankData] = useState<Bank_Account[]>([]);

    useEffect(() => {
        if (!AuthService.isLoggedIn()) {
            AuthService.doLogin();
        } else {
            DataService.performRequest(`/member/info${MemberService.getUrlAddition()}`,finishedLoading,setFinishedLoading,setMemberData,"member", navigate)
            DataService.performRequest(`/bankaccount${MemberService.getUrlAddition()}`,finishedLoading,setFinishedLoading,setBankData,"bank", navigate)
        }
    }, []);

    let bankAccountCounter = 0;

    const buildBankAccountTypeString = (array: string[]) => {
        let string = "";
        array.map(e => (string+="" + EnumToStringService.getBankAccountType(e) + ", "))
        return string.substring(0,string.length - 2)
    }

    if (!finishedLoading.bank || !finishedLoading.member) {
        return <Loading />
    }

    return (
        <div className="content">
            <Typography variant="h6">Persönliche Daten</Typography>
            <div className="tableDiv" style={{ width: props.isMobile ? "100%" : "50%", display: "inline-block" }}>
                <TitleTable title="Kontaktdaten" rows={memberData.type === "beg_Contacts" ? [
                    { name: "Mitgliedsnummer", value: memberData.memberNumber },
                    { name: "Anrede", value: memberData.salutation },
                    { name: "Titel", value: memberData.title },
                    { name: "Vorname", value: memberData.firstname },
                    { name: "Nachname", value: memberData.lastname },
                    { name: "Geburtsname", value: memberData.birthname },
                    { name: "Geburtsdatum", value: new Date(memberData.birthdate).toLocaleDateString() },
                    { name: "Geburtsort", value: memberData.birthplace },
                    { name: "Steuer-ID", value: memberData.taxNumber },
                    { name: "Konfession", value: "Anzeige noch nicht verfügbar" },
                    { name: "Straße", value: memberData.address_street },
                    { name: "Adresszusatz", value: memberData.address_extra },
                    { name: "Postleitzahl", value: memberData.address_postalcode },
                    { name: "Ort", value: memberData.address_city },
                    { name: "Telefon", value: memberData.phone },
                    { name: "E-Mail-Adresse", value: memberData.primaryEmail },
                ] : [
                    { name: "Mitgliedsnummer", value: memberData.memberNumber },
                    { name: "Name", value: memberData.name },
                    { name: "Straße", value: memberData.address_street },
                    { name: "Adresszusatz", value: memberData.address_extra },
                    { name: "Postleitzahl", value: memberData.address_postalcode },
                    { name: "Ort", value: memberData.address_city },
                    { name: "Telefon", value: memberData.phone },
                    { name: "E-Mail-Adresse", value: memberData.primaryEmail },
                    { name: "Umsatzsteuer-ID", value: memberData.taxIdNumber },
                ]} />
                {/*<Button fullWidth variant="outlined" onClick={() => navigate('/personaldata/edit')}>Bearbeiten</Button>*/}
            </div>
            <div className="tableDiv" style={{ width: props.isMobile ? "100%" : "50%", display: "inline-block", verticalAlign: "top" }}>
                {bankData.map(ba => {
                    bankAccountCounter++;
                    return (<><TitleTable title={`${bankAccountCounter}. Bankverbindung`} rows={[
                        { name: "Kontoinhaber", value: ba.name },
                        { name: "IBAN", value: ba.iban },
                        { name: "BIC", value: ba.bank.bic },
                        { name: "Name der Bank", value: ba.bank.name },
                        { name: "Einzugsermächtigung", value: ba.debit ? "Ja" : "Nein" },
                        { name: "In Verwendung für", value: buildBankAccountTypeString(ba.bankAccountTypes) },
                    ]} />
                    <Button fullWidth variant="outlined" onClick={() => navigate(`/bankaccount/edit/${ba.id}`)}>Bearbeiten</Button></>)
                })}
                <Button fullWidth variant="outlined" style={{marginTop: bankData.length > 0 ? "10px" : "0px"}} onClick={() => navigate(`/bankaccount/create`)}>Neues Konto Hinzufügen</Button>
            </div>
        </div>
    )
}

